import { NgModule } from '@angular/core';
import { ChartsModule } from 'ng2-charts';
import * as fromServices from './services';
import * as fromDirective from './directive';
import { Constants } from '@config/constants';
import * as fromComponents from './components';
import { AppComponent } from './app.component';
import { AuthenticationInterceptor } from './services';
import { AppRoutingModule } from './app-routing.module';
import { HttpClientModule } from '@angular/common/http';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AngularMaterialModule } from './angular-material.module';
import { HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { Ng2GoogleChartsModule } from 'ng2-google-charts';
import { FlexLayoutModule } from '@angular/flex-layout';
import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
@NgModule({
  declarations: [
    AppComponent,
    ...fromComponents.components,
    ...fromDirective.directives,
  ],
  imports: [
    FormsModule,
    ChartsModule,
    BrowserModule,
    HttpClientModule,
    AppRoutingModule,
    ReactiveFormsModule,
    AngularMaterialModule,
    BrowserAnimationsModule,
    Ng2GoogleChartsModule,
    FlexLayoutModule,
    NgxGoogleAnalyticsModule.forRoot('G-8522LXBM38'),
    NgxGoogleAnalyticsRouterModule,
    NgxJsonViewerModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthenticationInterceptor,
      multi: true,
    },
    { provide: MAT_DATE_LOCALE, useValue: 'en-GB' },
    HttpClient,
    Constants,

    ...fromServices.services,
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
